export default __webpack_public_path__ + "static/platinum-a4a1c6dd3bb3ba75eeaa8026b58001be.svg";